const ENCOURAGING_EMOJIS = ['👏', '🎯', '👌', '💪', '👍', '😎', '🙌', '🥳', '🎉', '🚀'];
const WIN_MESSAGES = {
  cloze: "Hai ricostruito il testo! Ogni Storiella completata è un augurio di buona giornata!",
  collegamenti: "Hai trovato tutti i collegamenti! Grazie per averci dato una mano a ricostruire l'italiano!",
  memoria: "Hai trovato tutte le coppie! La fortuna dei nostri Giochini è avere tanti bravi Cupidini!",
  serpentoni: "Hai trovato tutte le parole! Nessun labirinto è segreto a chi è maestro dell'alfabeto!",
  ortografia: "Obiettivo raggiunto! Ogni parola ricordata è un sorriso nella tua giornata!",
  spettri: "Hai riordinato le progressioni! Sistematizzare fa rima con imparare!",
  scalinata: "Hai trovato tutte le parole! Un gradino alla volta, in cima ad ogni scala c'è una svolta!",
};
const LOSS_MESSAGE = "Sbagliando s'impara: solo grazie all'errore il tuo italiano è migliore, forza!";

/** Results encourage players independently of performance or hint usage. */
export function buildGameResult(gameSlug, state = {}, puzzle = {}, won = state?.status === 'won') {
  const availableEmojis = [...ENCOURAGING_EMOJIS];
  const emojis = Array.from({ length: 3 }, () => (
    availableEmojis.splice(Math.floor(Math.random() * availableEmojis.length), 1)[0]
  )).join(' ');
  const summary = won ? (WIN_MESSAGES[gameSlug] || 'Hai completato il puzzle!') : LOSS_MESSAGE;
  return { heading: won ? 'Complimenti!' : 'La prossima sfida ti aspetta!', summary, emojis };
}

export function buildResultShareText(displayName, result) {
  return `${displayName}\n${result.summary}\n${result.emojis}\nProva anche tu!`;
}
